// @ts-nocheck
import React, {useReducer} from "react";
import {
    Box,
    Button,
    Stack,
    TextField,
} from '@mui/material'
import CollapseTagCard from "../CollapseTagCard";
import InfoIcon from "@mui/icons-material/Info";
import CollapseExamplesCard from "../CollapseExamplesCard";
import CollapseTextCard from "../CollapseTextCard";

export default function AddBrandsModalForm(
    {
        addToMainList,
    }
) {

    const [formData, updateFormData] = useReducer(
        (prev, next) => {
            return {...prev, ...next}
        }, {
        name: '',
        url: '',
        examplesTypeIsFile: false,
        examples: [],
        tags: {},
        aliases: [],
        texts: [],
    })

    function handleAddToMainList() {
        const {
            name,
            url,
            examplesTypeIsFile,
            examples,
            tags,
            aliases,
            texts,
        } = formData

        const brand = {
            name: name,
            url: url,
        }

        if(aliases.length > 0) {
            brand.aliases = aliases;
        }

        if(texts.length > 0) {
            brand.texts = texts;
        }

        if(examples.length > 0) {
            if (examplesTypeIsFile) {
                brand.exampleImagesBase64 = examples.map(el => el.base64);
            } else {
                brand.exampleUrls = examples;
            }
        }

        if (Object.keys(tags).length !== 0) {
            brand.meta = tags;
        }

       updateFormData(
           {
               name: '',
               url: '',
               examplesTypeIsFile: false,
               examples: [],
               tags: {},
           }
       )
        addToMainList(brand)
    }



    return (
        <Stack
            spacing={2}
            sx={{
                width: "100%",
                p: 1,
                position: 'sticky',
                top: 0,
            }}
        >
            <TextField
                id={'formAddBrands--Name'}
                label={`Brand Name*`}
                placeholder={'E.g. Coca Cola'}
                variant="standard"
                fullWidth
                value={formData.name}
                onChange={
                    e => {
                        updateFormData(
                            {name: e.target.value}
                        )
                    }
                }
            />

            <TextField
                id={'formAddBrands--url'}
                label={`Brand URL*`}
                placeholder={'E.g. https://coca-cola.com'}
                variant="standard"
                fullWidth
                value={formData.url}
                onChange={
                    e => {
                        updateFormData(
                            {url: e.target.value}
                        )
                    }
                }
            />
            <CollapseExamplesCard
                isAFile={formData.examplesTypeIsFile}
                setIsAFile={
                    val => updateFormData({examplesTypeIsFile : val})
                }
                examples={formData.examples}
                setExamples={
                    val => updateFormData(
                        {
                            examples: val
                        }
                    )
                }
            />
            <CollapseTagCard
                tags={formData.tags}
                setTags={newTags => updateFormData({tags: newTags})}
            />
            <CollapseTextCard
                texts={formData.texts}
                setTexts={newTexts => updateFormData({texts: newTexts})}
            />
            <Button
                variant={'contained'}
                fullWidth
                onClick={_ => {
                    return handleAddToMainList()
                }}
                sx={{
                    fontWeight: 'bold',
                }}
                disabled={
                    formData.name.length === 0 || formData.url.length === 0
                }
            >
                Add To List &gt;&gt;
            </Button>
            <Box
                sx={{
                    fontSize: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                }}>
                <InfoIcon sx={{fontSize: '14px', color: '#8092A6', mr: 1,}}/>
                <span>
                Brands will become active within your contracted time period.
                </span>
            </Box>
        </Stack>
    )
}
